import { BooleanField } from "aderant-conflicts-models";
import React from "react";
import { FieldWrapper } from "./FieldWrapper";

interface BooleanInformationProps {
    field: BooleanField;
}

export const BooleanInformation = (props: BooleanInformationProps): JSX.Element => {
    const {
        field: { fieldLabel, value }
    } = props;
    
    // Text to be displayed based on value provided
    const textValueToBeDisplayed = value === true ? "Yes" : "No";

    return (
        <FieldWrapper fieldLabel={fieldLabel}>
            {textValueToBeDisplayed}
        </FieldWrapper>
    );
};
